'use client'

import { useState } from 'react'
import { useExtracted } from 'next-intl'
import { Link } from '@/i18n/navigation'
import { ArrowRight } from '@/components/ui/icons'
import { useStoredSignupAccess } from '@/hooks/useStoredSignupAccess'
import { SignUpModal } from '@/components/auth'

export function ModelsCTA() {
  const t = useExtracted()
  const hasSignupAccess = useStoredSignupAccess()
  const [showSignUpModal, setShowSignUpModal] = useState(false)

  return (
    <section className="mb-16 py-10" aria-labelledby="cta-heading">
      <div className="group relative mx-auto max-w-3xl rounded-2xl border border-white/20 bg-white/10 p-8 shadow-lg backdrop-blur-xl transition-all duration-300 hover:border-white/25 hover:shadow-xl md:p-10">
        <h2 id="cta-heading" className="mb-6 text-2xl font-bold text-white md:text-3xl">
          {t('Ready to get started?')}
        </h2>
        <div className="mb-8 space-y-3 text-base leading-relaxed text-white/80 md:text-lg">
          <p>{t('For creatives, studios, and agencies who create professional AI videos.')}</p>
        </div>
        <div className="flex flex-col items-stretch gap-4 sm:flex-row sm:items-center">
          {hasSignupAccess ? (
            <button
              type="button"
              onClick={() => setShowSignUpModal(true)}
              className="group/btn inline-flex min-w-0 flex-1 items-center justify-center gap-2 rounded-xl bg-white px-8 py-6 text-base font-semibold text-black transition-all duration-300 hover:scale-[1.01] hover:bg-white/95 active:scale-[0.98] sm:flex-none md:text-lg"
            >
              {t('Get started free')}
              <ArrowRight className="h-5 w-5 transition-transform duration-300 group-hover/btn:translate-x-1" />
            </button>
          ) : (
            <a
              href="https://form.typeform.com/to/VVwyeUrj"
              target="_blank"
              rel="noopener noreferrer"
              className="group/btn inline-flex min-w-0 flex-1 items-center justify-center gap-2 rounded-xl bg-white px-8 py-6 text-base font-semibold text-black transition-all duration-300 hover:scale-[1.01] hover:bg-white/95 active:scale-[0.98] sm:flex-none md:text-lg"
            >
              {t('Request Access')}
              <ArrowRight className="h-5 w-5 transition-transform duration-300 group-hover/btn:translate-x-1" />
            </a>
          )}
          <Link
            href="/pricing"
            className="inline-flex h-auto min-h-[3.5rem] min-w-0 flex-1 items-center justify-center gap-2 rounded-xl border border-white/20 bg-white/5 px-8 py-6 text-base font-semibold text-white transition-all duration-300 hover:scale-[1.01] hover:border-white/30 hover:bg-white/10 active:scale-[0.98] sm:flex-none md:text-lg"
            aria-label={t('View Martini Pricing Plans')}
          >
            {t('View Pricing')}
          </Link>
        </div>
      </div>

      <SignUpModal
        isOpen={showSignUpModal}
        onClose={() => setShowSignUpModal(false)}
        returnPath="/projects"
        defaultMode="signup"
        variant="marketing"
      />
    </section>
  )
}
